"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
var _progressChart = _interopRequireDefault(require("./components/progressChart"));
var _report = require("@/api/report");
var _cookie = require("@/utils/cookie");
var _log = require("@/utils/log");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'UserProgressChart',
  components: {
    Chart: _progressChart.default
  },
  data() {
    return {
      videoId: [],
      videoTitle: [],
      universalScore: [],
      voiceRangeScore: [],
      weakLangScore: [],
      xAxis: [],
      vType: [],
      coachReview: [],
      isDataReady: false
    };
  },
  created() {
    this.getUserContent();
  },
  methods: {
    test() {
      console.log('Hello');
    },
    getUserInfo() {},
    getUserContent() {
      const uuid = typeof this.$route.params.id === 'undefined' ? this.trainingForm.id : this.$route.params.id;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      (0, _report.userContent)(token, uuid).then(response => {
        var data = response.data.rows;
        var seq = 1;
        for (var i = 0; i < data.length; i++) {
          // console.log('odata',data[i])
          if (data[i].analyzeType !== 'none' && data[i].analyzeMeta.report && data[i].analyzeMeta.report.status) {
            // console.log('data',data[i])
            // console.log('status' , data[i].analyzeMeta.report.status )
            if (data[i].analyzeMeta.report.status === 'completed') {
              if (typeof data[i].analyzeMeta.report.universal.score === 'undefined') {
                this.universalScore.push(0);
              } else {
                this.universalScore.push(data[i].analyzeMeta.report.universal.score);
              }
              if (typeof data[i].analyzeMeta.report.voiceRange.score === 'undefined') {
                this.voiceRangeScore.push(data[i].analyzeMeta.report.voiceRange.score);
              } else {
                this.voiceRangeScore.push(data[i].analyzeMeta.report.voiceRange.score);
              }
              if (typeof data[i].analyzeMeta.report.weakLanguage.score === 'undefined') {
                this.weakLangScore.push(0);
              } else {
                this.weakLangScore.push(data[i].analyzeMeta.report.weakLanguage.score);
              }
              if (typeof data[i].coachReview === 'undefined') {
                this.coachReview.push('');
              } else {
                this.coachReview.push(data[i].coachReview);
              }
              this.xAxis.push((0, _momentTimezone.default)(data[i].createdAt).format('YYYY-MMM-DD HH:mmZ'));
              this.videoId.push(data[i].id);
              this.videoTitle.push(data[i].title);
              this.vType.push(data[i].analyzeType);
              seq += 1;
            }
          }
        }
        this.isDataReady = true;
        // console.log('uscore', this.universalScore)
        // console.log('vscore', this.voiceRangeScore)
        // console.log('wscore',this.weakLangScore)
        // console.log('xAxis',this.xAxis)
      }).catch(error => {
        (0, _log.displayPopupMessage)(error, 'error');
      });
    }
  }
};